import React, { useRef, useState } from "react";
import biometricBackground from "../assets/biometric_facial_mesh.png";

const Banner = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const [iframe, setIframe] = useState(null);
  const videoRef = useRef(null);

  const handleCancel = () => {
    setIframe(null);
    if (videoRef.current) {
      const iframeElements = videoRef.current.querySelectorAll(".yvideo");
      iframeElements.forEach((iframe) => {
        iframe.setAttribute("src", null);
      });
    }
    setPlayVideo(false);
  };
  const styles = {
    mainsection: {
      position: "relative",
      overflow: "hidden",
    },
    background: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${biometricBackground})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      opacity: 0.12, 
      zIndex: 0,
      filter: "grayscale(100%) brightness(1.2)",
    },
    container: {
      position: "relative",
      zIndex: 1, // Ensure content is above the background
      // margin: "0px 250px",
    },
    banner: {
      color: "#333333",
      height: "500px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    content: {
      textAlign: "center",
    },
    title: {
      fontSize: "4.5rem",
      fontWeight: "800",
      marginBottom: "20px",
      letterSpacing: "-2px",
      color: "#FF0000",
      lineHeight: "1.1",
    },
    subtitle: {
      marginBottom: "30px",
      fontSize: "1.8rem",
      color: "#444444",
      fontWeight: "400",
    },
    description: {
      fontSize: "1rem",
      lineHeight: "1.5",
      marginBottom: "20px",
    },
    button: {
      padding: "16px 40px",
      fontSize: "1.1rem",
      fontWeight: "700",
      border: "none",
      cursor: "pointer",
      borderRadius: "50px",
      textTransform: "uppercase",
      letterSpacing: "1px",
      boxShadow: "0 6px 20px rgba(255, 0, 0, 0.3)",
      transition: "all 0.3s ease",
    },
    playButton: {
      backgroundColor: "#ff0000",
      color: "#fff",
    },
    buttonContainer: {
      position: "relative",
    },
    backbtn: {
      position: "absolute",
      top: "4px",
      right: "189px",
      color: "#fff",
      fontSize: "40px",
      cursor: "pointer",
    },
  };

  const getEmbedUrl = (url) => {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get("v");
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  const handlePlayVideo = () => {
    setPlayVideo(true);
    setIframe(getEmbedUrl("https://www.youtube.com/watch?v=6ZfuNTqbHE8"));
  };

  return (
    <div style={styles.mainsection}>
      <style>
        {`
          .play-btn:hover {
            transform: translateY(-3px) scale(1.02);
            box-shadow: 0 12px 30px rgba(255, 0, 0, 0.4) !important;
            background-color: #e60000 !important;
          }
          .play-btn:active {
            transform: translateY(0) scale(1);
          }
        `}
      </style>
      <div style={styles.background} />
      <div style={styles.container}>
        {!playVideo ? (
          <header style={styles.banner}>
            <div style={styles.content}>
              <h1 className="title" style={styles.title}>
                Secure Your Digital World with Legitimately U.
              </h1>
              <p className="Subtitle" style={styles.subtitle}>
                Zero-Trust biometric authentication for all your apps and enterprise services.
              </p>
              <p style={styles.description}>
                Log in with Legitimately U to start your verified session instantly.
              </p>
              <button
                style={{ ...styles.button, ...styles.playButton }}
                className="play-btn"
                onClick={() => window.open("https://web.legitimatelyu.com/", "_blank")}
              >
                ▶ Access with LU
              </button>
            </div>
          </header>
        ) : (
          <>
            <div style={styles.buttonContainer} className="back-btn-div">
              {/* <Button
                style={styles.backbtn}
                onClick={handleCancel}
                className="banner-back-btn"
              >
                Go Back
              </Button> */}
              <span style={styles.backbtn} onClick={handleCancel}>
                ×
              </span>
            </div>
            <iframe
              ref={videoRef}
              className="yvideo"
              width="100%"
              height="800px"
              src={iframe}
              title="The Masked Singer"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              style={{ backgroundColor: "black" }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Banner;
